export enum ChatConversationContextType {
  Task = "Task",
  Service = "Service"
}
